if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      setupGentleViewer(image) {
        this.classList.add('mdc-desktop-viewer');
        this.mdcImage = image;
        this.mdcZoom = 1;
        if (!this.mdcToolbar) {
          const toolbar = document.createElement('div');
          toolbar.className = 'mdc-image-tools';
          toolbar.addEventListener('click', event => event.stopPropagation());
          this.querySelector('[role="document"]').addEventListener('pointerup', event => {
            if (window.matchMedia('(min-width: 990px)').matches) event.stopPropagation();
          });
          toolbar.setAttribute('role', 'group');
          toolbar.setAttribute('aria-label', 'Image viewer controls');
          const addButton = (label, text, action) => {
            const button = document.createElement('button');
            button.type = 'button'; button.textContent = text;
            button.setAttribute('aria-label', label);
            button.addEventListener('click', action);
            toolbar.append(button); return button;
          };
          this.mdcPrevious = addButton('Previous image', '←', () => this.changeGentleImage(-1));
          this.mdcMinus = addButton('Zoom out', '−', () => this.setGentleZoom(this.mdcZoom - 0.25));
          this.mdcFit = addButton('Fit entire image', 'Fit', () => this.setGentleZoom(1));
          this.mdcPlus = addButton('Zoom in', '+', () => this.setGentleZoom(this.mdcZoom + 0.25));
          this.mdcNext = addButton('Next image', '→', () => this.changeGentleImage(1));
          this.querySelector('[role="document"]').append(toolbar);
          this.mdcToolbar = toolbar;
          this.addEventListener('keydown', event => {
            if (!this.classList.contains('mdc-desktop-viewer') || /INPUT|TEXTAREA/.test(event.target.tagName)) return;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
              event.preventDefault(); this.changeGentleImage(event.key === 'ArrowLeft' ? -1 : 1);
            }
          });
        }
        const fit = () => {
          if (this.mdcImage !== image) return;
          const ratio = image.naturalWidth / image.naturalHeight || 1;
          this.mdcFitWidth = Math.min(window.innerWidth - 120, (window.innerHeight - 160) * ratio);
          this.setGentleZoom(1);
        };
        if (image.complete && image.naturalWidth) fit();
        else image.addEventListener('load', fit, { once: true });
      }

      setGentleZoom(value) {
        this.mdcZoom = Math.max(1, Math.min(1.5, value));
        this.mdcImage.style.setProperty('--mdc-image-width', `${this.mdcFitWidth * this.mdcZoom}px`);
        this.mdcMinus.disabled = this.mdcZoom === 1;
        this.mdcPlus.disabled = this.mdcZoom === 1.5;
        this.mdcFit.textContent = this.mdcZoom === 1 ? 'Fit' : `${Math.round(this.mdcZoom * 100)}% · Fit`;
        const container = this.querySelector('[role="document"]');
        container.scrollTop = 0; container.scrollLeft = 0;
      }

      changeGentleImage(direction) {
        const images = Array.from(this.querySelectorAll('[role="document"] img[data-media-id]'));
        if (images.length < 2) return;
        const index = images.indexOf(this.mdcImage);
        this.mdcImage.classList.remove('active');
        const image = images[(index + direction + images.length) % images.length];
        image.classList.add('active');
        this.setupGentleViewer(image);
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        if (window.matchMedia('(min-width: 990px)').matches && activeMedia.tagName === 'IMG') {
          this.setupGentleViewer(activeMedia);
          return;
        }
        this.classList.remove('mdc-desktop-viewer');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}

